export enum FloorplanSidesheetExtent {
  None,
  Partially,
  Fully,
}
